import dayjs, { Dayjs } from 'dayjs';
import { TimeRange } from 'v2/core/entities';

export const isTimeAfterDateRange = (
  time: Dayjs,
  dateRange: TimeRange,
  timezone: string,
): boolean => {
  switch (dateRange.type) {
    case 'absolute':
      return time.isAfter(dateRange.endBefore, 'date');
    case 'last':
    case 'since':
      return time.isAfter(dayjs().tz(), 'date');
  }
};
